import { LeadVideoComponent } from 'components/video/playlist/lead-video.component'
export default LeadVideoComponent
